import { useState, ChangeEvent } from 'react'
import { useForm } from 'react-hook-form'
import { IFormInputs } from './NewUser.interface'

export const useNewUsers = () => {
  const [adminId, setAdminId] = useState('not-admin')

  const { register, control, setValue, watch } = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      isAdmin: false,
    },
  })

  const statusLabel = watch('isActive') ? 'Inativo' : 'Ativo'

  const accessList: { [key: string]: string } = {
    dashboard: 'Dashboard',
    prediction: 'Predições',
    products: 'Produtos',
    sellers: 'Vendedores',
    companies: 'Empresas',
    sheets: 'Importar Planilha',
    users: 'Usuários e Permissões',
  }

  const emailValidation = {
    required: true,
    pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
  }

  const handleGetId = ({ target: { id } }: ChangeEvent<HTMLInputElement>) => {
    setAdminId(() => id || '')
    setValue('isAdmin', id === 'admin')
  }

  return {
    adminId,
    accessList,
    control,
    emailValidation,
    handleGetId,
    register,
    statusLabel,
  }
}
